import React, { useContext, useEffect, useState } from "react";
// WAS (backlog #160 öncesi): Alert yoktu.
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Pagination, PaginationItem, PaginationLink, Card, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Alert, Badge, Spinner } from "reactstrap";
import BreadCrumb from "../../../../../Components/Common/BreadCrumb";
import MailSettingsContext from "../../../../../Components/Contexts/Management/MailSettingsContext";
import Select from 'react-select';
import { useTranslation } from "react-i18next";
import i18n from "../../../../../i18n";
import SmtpAlanlari from "./SmtpAlanlari";
import { sendAccountTest } from "../../../../../services/emailAyarService";

// #573: yeni hesapta boş SMTP alanları (backend #566). Boş sunucu = hesap gönderemez; varsayılan olması için sunucu + şifre gerekir.
const SMTP_BOS = { smtp_host: "", smtp_port: "", smtp_security: "", smtp_username: "", smtp_from_name: "", is_default: false };
// Şifrenin kendisi değil, "nereye giriş yapılıyor" alanları: bunlar değişirse şifre yeniden yazılmalı (backend de aynısını ister).
const HEDEF_ALANLARI = ['smtp_host', 'smtp_port', 'smtp_security', 'smtp_username'];
// backend sunucuyu küçük harfe, güvenliği büyük harfe çevirip karşılaştırır; kullanıcı adı olduğu gibi (büyük/küçük harf farkı da bir değişikliktir)
const norm = (k, v) => {
    const s = v === null || v === undefined ? '' : String(v).trim();
    return k === 'smtp_host' || k === 'smtp_security' ? s.toLowerCase() : s;
};

/**
 * Sistem Ayarları › E-posta Hesapları (system_email). Backlog #160 (2026-10-10): artık FDS-Backend
 * EmailController'a bağlı (bkz. MailSettingsContext). Şifre sütunu ŞİFREYİ GÖSTERMİYOR: backend şifreyi hiç
 * dönmüyor, yalnızca kayıtlı olup olmadığını (has_password). Düzenlemede şifre boş = değişmez.
 * Ekleme/düzenleme/silme SYSTEM_SETTINGS_MANAGE ister (Admin / SuperAdmin); hata mesajı sayfada görünür.
 *
 * #573 (backend #566): hesap artık NEREDEN ve NASIL gönderdiğini de taşır (sunucu, port, SSL | STARTTLS, SMTP kullanıcı adı, gönderen adı, "sistemin
 * varsayılan göndericisi" — SmtpAlanlari). Şifre rozeti üç durum gösterir: şifreli saklı / düz metin saklı (eski kayıt) / yok. Sunucu, port, güvenlik ya
 * da SMTP kullanıcı adı değişince şifre yeniden yazılmadan Kaydet açılmaz (sunucuyu kendi makinesine çeviren biri şifreyi okuyamasın diye backend de ister).
 * Satırdaki "Bana test gönder" hesabın çalıştığını giriş yapan personelin KENDİ adresine dener (güvenli mod geçerlidir); sonuç sayfada görünür.
 */
const Configs = () => {
  const { t } = useTranslation("moduller");
    useEffect(() => { document.title = i18n.t("moduller:emailsConfigs.ayarlarFds"); }, []);

    // WAS: const { mailSettings, fetchMailSettings, addMailSetting, updateMailSetting, deleteMailSetting, searchMailUsers, loading } = useContext(MailSettingsContext);
    const { mailSettings, fetchMailSettings, addMailSetting, updateMailSetting, deleteMailSetting, searchMailUsers, loading, loadError } = useContext(MailSettingsContext);
    // #160: ekle/düzenle/sil hatası (403 yetki, geçersiz e-posta …).
    const [actionError, setActionError] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false); // Silme onay modali için state
    const [deleteId, setDeleteId] = useState(null);
    const [selectedMail, setSelectedMail] = useState(null);
    const [userOptions, setUserOptions] = useState([]);
    // #573: düzenleme penceresi açıldığındaki satır (hedef alanlarının değişip değişmediğini bununla karşılaştırıyoruz) ve "bana test gönder" durumu
    const [origMail, setOrigMail] = useState(null);
    const [testSonucu, setTestSonucu] = useState(null);
    const [testIsteniyor, setTestIsteniyor] = useState(null);
    const [newMail, setNewMail] = useState({
        system_email_title: "",
        system_email_value: "",
        system_email_password: "",
        user_id: 0,
        type_id: 1,
        ...SMTP_BOS
    });

    useEffect(() => {
        fetchMailSettings(page, limit, search);
    }, [page, limit, search, fetchMailSettings]);

    const toggleModal = () => setModalOpen(!modalOpen);

    const toggleEditModal = (mail) => {
        setSelectedMail(mail);
        setOrigMail(mail);   // #573

        if (mail && mail.user_id && mail.user_name && mail.user_surname) {
            setSelectedUser({ label: `${mail.user_name} ${mail.user_surname}`, value: mail.user_id });
        } else {
            setSelectedUser(null);
        }

        setEditModalOpen(!editModalOpen);
    };

    const toggleDeleteModal = (id) => {
        setDeleteId(id);
        setDeleteModalOpen(!deleteModalOpen); // Silme onay modalini aç/kapat
    };

    // WAS (backlog #160 öncesi): hata yakalanmıyordu (context hatayı yutuyordu).
    // const handleDeleteMail = async () => {
    //     if (deleteId) {
    //         await deleteMailSetting(deleteId); // Onay alındığında silme işlemi yapılır
    //         setDeleteModalOpen(false);
    //     }
    // };
    const handleDeleteMail = async () => {
        if (deleteId) {
            setActionError(null);
            try {
                await deleteMailSetting(deleteId); // Onay alındığında silme işlemi yapılır
            } catch (e) {
                setActionError(e.message);
            }
            setDeleteModalOpen(false);
        }
    };

    const handleAddMail = async () => {
        // Seçili kullanıcı varsa user_id'yi ayarla; yoksa 0 olarak kalsın
        const mailToAdd = {
            ...newMail,
            user_id: selectedUser ? selectedUser.value : 0,
            is_default: selectedUser ? false : Boolean(newMail.is_default)   // #573: atanmış hesap varsayılan olamaz
        };
        // WAS (backlog #160 öncesi): listeyi eklemeden ÖNCE çekiyordu, hata yakalanmıyordu.
        // fetchMailSettings(page, limit, search);
        // await addMailSetting(mailToAdd);
        setActionError(null);
        try {
            await addMailSetting(mailToAdd);
        } catch (e) {
            setActionError(e.message);
            return;   // modal açık kalsın, kullanıcı düzeltsin
        }
        fetchMailSettings(page, limit, search);
        toggleModal();
        setNewMail({
            system_email_title: "",
            system_email_value: "",
            system_email_password: "",
            user_id: 0,
            type_id: 1,
            ...SMTP_BOS
        });
        setSelectedUser(null); // Seçili kullanıcıyı temizle
    };

    const renderPagination = () => {
        const totalPages = mailSettings.totalPages || 1;
        const paginationItems = [];

        for (let i = 1; i <= totalPages; i++) {
            paginationItems.push(
                <PaginationItem key={i} active={i === page}>
                    <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
                </PaginationItem>
            );
        }
        return paginationItems;
    };

    const handleEditMail = async () => {
        try {
            if (selectedMail) {
                // Güncellenmiş kullanıcı verilerini selectedMail'e ekliyoruz
                const updatedMail = {
                    ...selectedMail,
                    user_id: selectedUser ? selectedUser.value : 0, // Seçili kullanıcı yoksa 0 atıyoruz
                    is_default: selectedUser ? false : Boolean(selectedMail.is_default)   // #573
                };

                setActionError(null);
                await updateMailSetting(selectedMail.system_email_id, updatedMail);
                toggleEditModal(null); // Modalı kapat
                // WAS: fetchMailSettings(); // Değişiklikleri görmek için listeyi yeniden yükleyin
                fetchMailSettings(page, limit, search); // aynı sayfa / arama
            }
        } catch (error) {
            console.error("Error updating mail setting:", error);
            setActionError(error.message);   // #160
        }
    };

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    // #573: "Bana test gönder" — SENT | BLOCKED (güvenli mod) | FAILED (neden `error` alanında; şifre çözülemiyor da burada görünür). Üçü de HTTP 200.
    const handleTest = async (mail) => {
        setTestIsteniyor(mail.system_email_id);
        setTestSonucu(null);
        try {
            const r = await sendAccountTest(mail.system_email_id);
            setTestSonucu({ hesap: mail.system_email_title, status: r.status, message: r.message, error: r.error });
        } catch (e) {
            setTestSonucu({ hesap: mail.system_email_title, status: 'ERROR', message: e.message, error: null });
        } finally {
            setTestIsteniyor(null);
        }
    };
    const testRengi = (s) => (s === 'SENT' ? 'success' : s === 'BLOCKED' ? 'warning' : 'danger');

    const handleUserSearch = async (inputValue = "") => {
        if (!inputValue || typeof inputValue !== "string") return; // Geçersiz veya boş değerleri atla

        try {
            const users = await searchMailUsers(inputValue);
            if (Array.isArray(users)) {
                const options = users.map(user => ({
                    label: `${user.user_name} ${user.user_surname}`,
                    value: user.user_id
                }));
                setUserOptions(options);
            } else {
                console.error("Beklenmeyen arama sonucu:", users);
            }
        } catch (error) {
            console.error("Kullanıcı ararken hata oluştu:", error);
        }
    };

    // #573: kayıtlı şifresi olan bir hesabın giriş hedefi değişti ama şifre yeniden yazılmadı → Kaydet kapalı
    const hedefDegisti = Boolean(origMail && selectedMail && origMail.has_password &&
        HEDEF_ALANLARI.some((k) => norm(k, origMail[k]) !== norm(k, selectedMail[k])));
    const sifreGerekli = hedefDegisti && !selectedMail?.system_email_password;

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title={t("emailsConfigs.ayarlar")} pageTitle={t("emailsConfigs.emails")} />
                <Card className="p-3">
                    <Row>
                        <Col md="1">
                            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                <DropdownToggle color="primary" caret>
                                    {t("emailsConfigs.gosterim", { limit })}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={() => setLimit(10)}>10</DropdownItem>
                                    <DropdownItem onClick={() => setLimit(25)}>25</DropdownItem>
                                    <DropdownItem onClick={() => setLimit(50)}>50</DropdownItem>
                                    <DropdownItem onClick={() => setLimit(100)}>100</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                        <Col md="3">
                            <Input type="text" placeholder={t("emailsConfigs.arama")} value={search} onChange={(e) => setSearch(e.target.value)} />
                        </Col>
                        <Col md="8" className="text-end">
                            <Button color="primary" onClick={toggleModal}>{t("emailsConfigs.mailEkle")}</Button>
                        </Col>
                    </Row>
                </Card>
                {/* #160 */}
                {loadError && <Alert color="danger" className="py-2">{loadError}</Alert>}
                {actionError && <Alert color="danger" className="py-2" toggle={() => setActionError(null)}>{actionError}</Alert>}
                {testSonucu && (
                    <Alert color={testRengi(testSonucu.status)} className="py-2" toggle={() => setTestSonucu(null)}>
                        <strong>{t("emailsConfigs.testSonucu", { hesap: testSonucu.hesap })}: </strong>{testSonucu.message}
                        {testSonucu.error && <span className="d-block small">{testSonucu.error}</span>}
                    </Alert>
                )}
                <Card className="pe-3 ps-3 pt-3">
                    {loading ? (
                        <div>{t("common:yukleniyor")}</div>
                    ) : (
                        <Table responsive bordered striped>
                            <thead>
                                <tr style={{ height: '40px' }}>
                                    <th>{t("emailsConfigs.baslik")}</th>
                                    <th>{t("emailsConfigs.email")}</th>
                                    <th>{t("emailsConfigs.sifre")}</th>
                                    <th>{t("emailsConfigs.atanmisKullanici")}</th>
                                    <th>{t("emailsConfigs.mailHost")}</th>
                                    <th>{t("emailsConfigs.smtpSunucu")}</th>
                                    <th>{t("emailsConfigs.islem")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {mailSettings.data?.map(mail => (
                                    <tr style={{ height: '65px' }} key={mail.system_email_id}>
                                        <td>
                                            {mail.system_email_title}
                                            {mail.is_default && <Badge color="primary" className="ms-2">{t("emailsConfigs.varsayilan")}</Badge>}
                                        </td>
                                        <td>{mail.system_email_value}</td>
                                        {/* WAS (backlog #160 öncesi): <td>{mail.system_email_password}</td> — şifre düz metin görünüyordu */}
                                        <td>
                                            {/* WAS (until #573): has_password → "kayıtlı" / "yok". Şimdi şifrelenmiş mi de görünüyor. */}
                                            {!mail.has_password
                                                ? <Badge color="secondary">{t("emailsConfigs.yok")}</Badge>
                                                : mail.password_encrypted
                                                    ? <Badge color="success">{t("emailsConfigs.sifreSifreli")}</Badge>
                                                    : <Badge color="warning" title={t("emailsConfigs.sifreDuzMetinAciklama")}>{t("emailsConfigs.sifreDuzMetin")}</Badge>}
                                        </td>
                                        <td>
                                            {mail.user_id === 0 ? (
                                                t("emailsConfigs.genel")
                                            ) : (
                                                <a href={`/user/${mail.user_id}`}>
                                                    {mail.user_name} {mail.user_surname}
                                                </a>
                                            )}
                                        </td>
                                        <td>{mail.type_id === 1 ? t("emailsConfigs.yandex") : t("emailsConfigs.diger")}</td>
                                        <td>
                                            {mail.smtp_host
                                                ? <span>{mail.smtp_host}{mail.smtp_port ? `:${mail.smtp_port}` : ""}{mail.smtp_security ? ` · ${mail.smtp_security}` : ""}</span>
                                                : <span className="text-muted">—</span>}
                                        </td>
                                        <td>
                                            <Button
                                                color="primary"
                                                outline
                                                className="me-2"
                                                disabled={testIsteniyor !== null}
                                                onClick={() => handleTest(mail)}
                                            >
                                                {testIsteniyor === mail.system_email_id ? <Spinner size="sm" /> : t("emailsConfigs.testGonder")}
                                            </Button>
                                            <Button
                                                color="warning"
                                                className="me-2"
                                                onClick={() => toggleEditModal(mail)}
                                            >
                                                {t("common:duzenle")}
                                            </Button>
                                            <Button color="primary" onClick={() => toggleDeleteModal(mail.system_email_id)}>
                                                {t("common:sil")}
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Card>
                <Pagination className="pagination justify-content-center mt-3">
                    {renderPagination()}
                </Pagination>

                <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
                    <ModalHeader toggle={toggleModal}>{t("emailsConfigs.yeniMailEkle")}</ModalHeader>
                    <ModalBody>
                        <Input
                            className="mb-3"
                            type="text"
                            placeholder={t("emailsConfigs.baslik")}
                            value={newMail.system_email_title}
                            onChange={(e) => setNewMail({ ...newMail, system_email_title: e.target.value })}
                        />
                        <Input
                            className="mb-3"
                            type="email"
                            placeholder={t("emailsConfigs.emailAdresi")}
                            value={newMail.system_email_value}
                            onChange={(e) => setNewMail({ ...newMail, system_email_value: e.target.value })}
                        />
                        <Input
                            className="mb-3"
                            type="password"
                            placeholder={t("emailsConfigs.sifre")}
                            value={newMail.system_email_password}
                            onChange={(e) => setNewMail({ ...newMail, system_email_password: e.target.value })}
                        />
                        <SmtpAlanlari deger={newMail} degistir={(p) => setNewMail({ ...newMail, ...p })} kullaniciSecili={Boolean(selectedUser)} />
                        <Select
                            options={userOptions}
                            value={selectedUser}
                            onInputChange={(inputValue) => {
                                console.log("Input Change Değeri:", inputValue); // Değeri kontrol etmek için
                                handleUserSearch(inputValue);
                            }}
                            onChange={(selected) => setSelectedUser(selected)} // Tek seçim için setSelectedUser kullanın
                            placeholder={t("emailsConfigs.kullaniciArayin")}
                            className="data-choices form-control mb-3"
                            isClearable
                            styles={{
                                color: 'white',
                                multiValueLabel: (base) => ({
                                    ...base,
                                    color: 'white', // Seçili etiketlerin metnini beyaz yap
                                })
                            }}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={handleAddMail}>{t("common:ekle")}</Button>
                        <Button color="primary" onClick={toggleModal}>{t("common:iptal")}</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={editModalOpen} toggle={() => toggleEditModal(null)} size="lg">
                    <ModalHeader toggle={() => toggleEditModal(null)}>{t("emailsConfigs.mailDuzenle")}</ModalHeader>
                    <ModalBody>
                        <Input
                            className="mb-3"
                            type="text"
                            value={selectedMail?.system_email_title || ""}
                            onChange={(e) => setSelectedMail({ ...selectedMail, system_email_title: e.target.value })}
                        />
                        <Input
                            className="mb-3"
                            type="email"
                            value={selectedMail?.system_email_value || ""}
                            onChange={(e) => setSelectedMail({ ...selectedMail, system_email_value: e.target.value })}
                        />
                        {/* #160: şifre yalnızca yazılır; boş bırakılırsa kayıtlı şifre korunur. */}
                        <Input
                            className="mb-3"
                            type="password"
                            autoComplete="new-password"
                            placeholder={selectedMail?.has_password ? t("emailsConfigs.yeniSifreBosDegismez") : t("emailsConfigs.sifre")}
                            value={selectedMail?.system_email_password || ""}
                            onChange={(e) => setSelectedMail({ ...selectedMail, system_email_password: e.target.value })}
                        />
                        {/* #573 */}
                        {selectedMail?.has_password && !selectedMail?.password_encrypted && !sifreGerekli &&
                            <Alert color="warning" className="py-2 small">{t("emailsConfigs.sifreDuzMetinAciklama")}</Alert>}
                        {sifreGerekli && <Alert color="warning" className="py-2 small">{t("emailsConfigs.sifreHedefDegisti")}</Alert>}
                        <SmtpAlanlari deger={selectedMail} degistir={(p) => setSelectedMail({ ...selectedMail, ...p })} kullaniciSecili={Boolean(selectedUser)} />
                        {/* Kullanıcı seçimi alanı */}
                        <Select
                            options={userOptions}
                            value={selectedUser}
                            onInputChange={(inputValue) => {
                                console.log("Input Change Değeri:", inputValue); // Değeri kontrol etmek için
                                handleUserSearch(inputValue);
                            }}
                            onChange={(selected) => setSelectedUser(selected)} // Tek seçim için setSelectedUser kullanın
                            placeholder={t("emailsConfigs.kullaniciArayin")}
                            className="data-choices form-control mb-3"
                            isClearable
                            styles={{
                                color: 'white',
                                multiValueLabel: (base) => ({
                                    ...base,
                                    color: 'white', // Seçili etiketlerin metnini beyaz yap
                                })
                            }}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" disabled={sifreGerekli} onClick={handleEditMail}>{t("common:kaydet")}</Button>
                        <Button color="primary" onClick={() => toggleEditModal(null)}>{t("common:iptal")}</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={deleteModalOpen} toggle={() => toggleDeleteModal(null)}>
                    <ModalHeader toggle={() => toggleDeleteModal(null)}>{t("emailsConfigs.onay")}</ModalHeader>
                    <ModalBody>{t("emailsConfigs.buMailKaydiniSilmekIstediginizden")}</ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={handleDeleteMail}>{t("common:sil")}</Button>
                        <Button color="primary" onClick={() => toggleDeleteModal(null)}>{t("common:iptal")}</Button>
                    </ModalFooter>
                </Modal>
            </Container>
        </div>
    );
};

export default Configs;
